var map = {
	"./anxiang/icon_shield.png": "2z8/",
	"./default/icon_shield.png": "KTO1",
	"./huarong/icon_shield.png": "O82M",
	"./master/icon_shield.png": "fmf8",
	"./shaodong/icon_shield.png": "Av56",
	"./taoyuan/icon_shield.png": "AOB9",
	"./yueyang/icon_shield.png": "HWM2",
	"./zhuzhou/icon_shield.png": "xcv3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4t4y";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\/icon_shield\.png$
// module id = 4t4y
// module chunks = 1